import { TenantRole } from '@bybeam/identity-client/types';
import { IdentityPaths } from '@platform-ui/auth/Routes.js';
import useAuth, { AuthProvider } from '@platform-ui/auth/hooks/useAuth/index.js';
import { TenantProvider } from '@platform-ui/auth/hooks/useTenant.js';
import UserInactivityProvider from '@platform-ui/auth/providers/UserInactivityProvider.js';
import { Route, RouteProps } from 'react-router-dom';
import { Navigate } from 'react-router-dom-v5-compat';

enum Routes {
  // Top-level-routes
  ELIGIBILITY = '/eligibility',
  LEGACY_INTRO = '/intro',
  IDENTITY = '/identity',
  PROGRAM = '/program/:programId',
  APPLICATION = '/application',
  CLAIM = '/claim',
  PORTAL = '/portal',
  CASE = '/case',
}
export default Routes;

export function useUserHomeRoute(): string {
  const { user, resetAuthState } = useAuth();
  if (!user?.core) return IdentityPaths.SIGNIN;
  if (user?.core?.admin) {
    resetAuthState();
    return IdentityPaths.SIGNIN;
  }
  return Routes.APPLICATION;
}

export function makeRoute(route: string, params?: Record<string, string>): string {
  return Object.entries(params ?? {}).reduce(
    (path, [param, value]) => path.replace(`:${param}`, value),
    route,
  );
}

export function AuthenticatedRoute({
  tenantRole,
  ...props
}: RouteProps & { tenantRole?: TenantRole }): JSX.Element {
  return (
    <TenantProvider tenantRole={tenantRole}>
      <AuthProvider>
        <UserInactivityProvider>
          <Route {...props} />
        </UserInactivityProvider>
      </AuthProvider>
    </TenantProvider>
  );
}

export function UnauthenticatedRedirect() {
  return <Navigate to={IdentityPaths.SIGNIN} replace />;
}
